import { render, staticRenderFns } from "./InsurerRatesMarkups.vue?vue&type=template&id=544454ef"
import script from "./InsurerRatesMarkups.vue?vue&type=script&lang=js"
export * from "./InsurerRatesMarkups.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/flexiquote/flexiquote/uniqms-vue-app/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('544454ef')) {
      api.createRecord('544454ef', component.options)
    } else {
      api.reload('544454ef', component.options)
    }
    module.hot.accept("./InsurerRatesMarkups.vue?vue&type=template&id=544454ef", function () {
      api.rerender('544454ef', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/insurer/InsurerRatesMarkups.vue"
export default component.exports